export default "assets/images/chateaux-logos/GBLF-acb206ef.png";